/**
 * Détermine les plans applicables au type d'utilisateur connecté et le plan
 * « le plus complet » (utilisé pour l'essai gratuit).
 */
import {
  PRO_PLAN_IDS,
  AGENT_PLAN_IDS,
  INVESTOR_PLAN_IDS,
  HUNTER_PLAN_IDS,
  WHITE_PLAN_IDS,
  INDIVIDUAL_PLAN_IDS,
} from "../Pages/ProOffers/planIds.config";

/**
 * Variant de plans à afficher sur /upgrade-plan pour ce user.
 * - investor → plans investisseur
 * - hunter   → plans chasseur
 * - agent    → plans agent indépendant
 * - agency   → plans agence / marque blanche
 * - individual → plans pro (repli ; pas de plans particuliers dédiés)
 */
export const planVariantForUser = (user) => {
  const role = String(user?.role || "").toLowerCase();
  const isPro = user?.accountType === "pro" || !!user?.agencyOwnerId;
  if (!isPro) return "individual";
  if (role === "investor") return "investor";
  if (role === "hunter") return "hunter";
  if (role === "agent") return "agent";
  return "agency";
};

/** Variant ProPlansSection correspondant au type de user. */
export const proPlansVariantForUser = (user) => {
  const v = planVariantForUser(user);
  if (v === "investor" || v === "hunter" || v === "agent" || v === "individual") return v;
  if (v === "agency") return user?.whiteLabelActive ? "white" : "pro";
  return "pro";
};

/** Libellé lisible du plan le plus complet du type de user. */
export const topPlanIdForUser = (user) => {
  switch (planVariantForUser(user)) {
    case "investor":
      return INVESTOR_PLAN_IDS.scale;
    case "hunter":
      return HUNTER_PLAN_IDS.pro;
    case "agent":
      return AGENT_PLAN_IDS.croissance;
    case "agency":
      if (user?.whiteLabelActive) return WHITE_PLAN_IDS.reseau;
      return PRO_PLAN_IDS.scale;
    case "individual":
      return INDIVIDUAL_PLAN_IDS.duo;
    default:
      return null;
  }
};

export default { planVariantForUser, proPlansVariantForUser, topPlanIdForUser };
